import { cn } from '@theprintbar/shared';
import React from 'react';
import type { HTMLAttributes } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
	className?: string;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(function Card({ className, ...rest }, ref) {
	return <div className={cn('rounded-3xl bg-white p-5 border border-blue', className)} {...rest} />;
});
